<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-four-sunday">
<h1>Chapter Four<br/> (Sunday)</h1>
<p><em>Jamie</em></p>
<p>“What’s up, love? Apart from you, obviously!”</p>
<p>I looked down to see who was there, as a blonde-haired girl materialised on the bed next to mine.</p>
<p>“Hi, I’m Alicia, who are you?” she asked.</p>
<p>“Jamieson.”</p>
<p>“What is wrong then, Jamieson, why are you up there, you know there really isn’t enough room for that?”</p>
<p>“I honestly do not have a clue what is going on, I can’t sit down. Why am I even bothering you with this, I don’t even know you!”</p>
<p>“You are telling me because I asked, so how come you are over here and not back in Canada? Which part are you from? I’ve got relations out there.”</p>
<p>“Alberta, the Peddler district.”</p>
<p>“Really, that’s where my cousins live. Do you know the Applewoods? One of my cousins is the same age as me.”</p>
<p>“Oh my gosh, Ashley’s cousin? She’s my best friend. We’ve known each other since like third grade! I can’t believe it, Wow!”</p>
<p>“You’re THAT, Jamie?”</p>
<p>“Yeah, why? What’s she been telling you?”</p>
<p>“That you are really secretive, and the best friend that she’s ever had, all that sort of thing, she said she hasn’t seen you for a while though, I’m guessing I can see why…”</p>
<p>“Yeah, well duh! So does your family know about you then or don’t they care about where you are?” I started to get a little defensive.</p>
<p>“No, they think this is a normal boarding school, well apart from my brother, he goes here as well, what about your family, do they know?”</p>
<p>“Well, if it comes as any surprise they do know, I can’t really hide it that much. It’s better for everyone if I’m far away from them.”</p>
<p>There was a knock at the door.</p>
<p>“Jamie? Jamie, can I talk to you?” Scott stepped into the room.</p>
<p>The chat that I’d had with Alicia had sorted my wings out; I was standing in the middle of the room.</p>
<p>“What’s it about? Lights go out in a minute, don’t they? We might get caught.”</p>
<p>“Oh yeah, I’ll find you in the morning, night.”</p>
<p>“Night then.”</p>
<p>As soon as the door closed, my wings went mental again.</p>
<p>“I think that I have found the reason for your problem, my dear.”</p>
<p>“What is it? Please tell me.”</p>
<p>“Firstly, tell me who that cute boy was in our room, and then I will tell you.”</p>
<p>“His name is Scott, I met him yesterday, we met up again this evening as well, now tell me?”</p>
<p>“He is the reason, you are in love. Well, your body is at least, I can’t blame you, he is absolutely gorgeous!” she exclaimed whilst fanning her face with her hand.</p>
<p>“Give me a break and leave him alone.” The room went dark.</p>
<p>“I like him too,” I muttered to myself.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?44743752